import { Injectable } from '@angular/core';
import { Color } from '../models/new/style';

@Injectable({
	providedIn: 'root'
})
export class ColorMapper {
	constructor() {}

	toColor(color: any) {
		return new Color({
			id: color.id,
			name: `${color.code} ${color.finalColorName}`
		});
	}
}
